import axios from "axios";
import { useAuthStore } from "../../stores/stores";
import { message } from "antd";
import { HelpService } from "../../service/helper.service";
import { routesConfig } from "../routes";
export const BASE_URL = process.env.REACT_APP_BASE_API_URL?.replaceAll('"', "");
const helpService = new HelpService();
export const axiosConfig = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const axiosConfigUpload = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  withCredentials: false,
  headers: {
    "Content-Type": "multipart/form-data",
    ...(localStorage.getItem("schoolManagement")
      ? { "x-enterprise-uuid": localStorage.getItem("schoolManagement") }
      : {}),
  },
});

axiosConfig.interceptors.request.use(
  (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const enterpriseUuid = localStorage.getItem("schoolManagement");
    if (enterpriseUuid) {
      config.headers["x-enterprise-uuid"] = enterpriseUuid;
    }
    const lang = localStorage.getItem("mooc_language") || "vi";
    config.headers["Accept-Language"] = lang;
    return config;
  },
  (error) => Promise.reject(error)
);

axiosConfigUpload.interceptors.request.use(
  (config) => {
    const accessToken = useAuthStore.getState().accessToken;
    if (!config.headers["Authorization"] || accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    const enterpriseUuid = localStorage.getItem("schoolManagement");
    if (enterpriseUuid) {
      config.headers["x-enterprise-uuid"] = enterpriseUuid;
    }
    const lang = localStorage.getItem("mooc_language") || "vi";
    config.headers["Accept-Language"] = lang;
    return config;
  },
  (error) => Promise.reject(error)
);
const currentUrl = new URL(window.location.href);

axiosConfig.interceptors.response.use(
  async (response) => {
    if (currentUrl.pathname.replace(/^\//, "") === routesConfig.maintenance) {
      window.history.length > 2
        ? window.history.back()
        : (window.location.href = "/");
    }
    return response;
  },
  async (error) => {
    const prevRequest = error?.config;

    if (!error.response) {
      console.error("Network or CORS error:", error.message);

      message.error("Lỗi mạng hoặc CORS: Không thể kết nối tới máy chủ.");
      return Promise.reject(error);
    }

    if (error?.response?.status === 403 && !prevRequest?.sent) {
      prevRequest.sent = true;
      try {
        const refreshToken = useAuthStore.getState().refreshToken;
        const accessToken = useAuthStore.getState().accessToken;
        if (refreshToken && accessToken) {
          prevRequest.headers["Authorization"] = `Bearer ${accessToken}`;
          return axiosConfig(prevRequest);
        }
      } catch (error) {
        location.replace("/login");
      }
    } else if (
      error?.response?.status === 401 ||
      error?.response?.status === 503
    ) {
      const logout = useAuthStore.getState().logout;
      logout();
    } else if (error?.response?.status === 502) {
      if (currentUrl.pathname !== "/" + routesConfig.maintenance) {
        currentUrl.pathname = "/maintenance";
        window.location.href = currentUrl.href;
      }
    } else {
      helpService.showMessageErrorAPI(error);
    }
    return Promise.reject(error);
  }
);
